import { Country } from '~/Api/Country';

export enum ErrorCode {
	cannotChangeSettingsForNonMemberProducts = 'croatia-max-price-calculation-cannot-change-settings-for-non-member-products',
	exportRequiresReferenceCountries = 'croatia-max-price-export-requires-reference-countries',
	illegalPriceTypeSelected = 'croatia-max-price-illegal-price-type-selected',
	requiredProductSettingsMissing = 'croatia-max-price-calculation-required-product-settings-is-missing',
	requiresMaxOneReferenceProduct = 'croatia-max-price-calculation-requires-at-most-one-product-for-each-country',
	requiresMinOneReferenceProduct = 'croatia-max-price-calculation-requires-at-least-one-reference-country-product',
	requiresReferenceSettings = 'croatia-max-price-calculation-requires-reference-settings',
}

export class Error {
	public constructor(
		public readonly code: string,
		public readonly productId: string | null,
		public readonly duplicateCountries: Country[]
	) {}
}
